// extracted by mini-css-extract-plugin
module.exports = {"notice":"CryptoRewardsBuySuccessStep__notice__A27zt","successIconWrapper":"CryptoRewardsBuySuccessStep__successIconWrapper__9fIWF"};